import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const state = {
  currentSiteInfo: null,
  currentCompanyShotName: null,
}
const mutations = {
  CHANGE_CURRENT_SITE_INFO: (state, active) => {
    console.log('设置网点数据mutations', active)
    state.currentSiteInfo = active
  },
  CHANGE_CURRENT_COMPANY_SHOT_NAME: (state, active) => {
    console.log('设置厂商简称mutations', active)
    state.currentCompanyShotName = active
  },
}

const store = new Vuex.Store({
  state,
  mutations,
  modules,
  getters
})

export default store
